import styles from "./user_object.module.css";
import {Flex, Row} from "antd";
import {EyeOutlined, MessageOutlined} from "@ant-design/icons";


export default function UserObject({userObject}) {
    return (
        <div className={styles.user_container}>
            <Row className={styles.user_first_row}>
                <Flex gap="middle" horizontal="center" align="center" justify="center" style={{width: "100%"}}>
                    <p className={styles.user_name}>{userObject.username}</p>
                </Flex>
            </Row>
        </div>
    )
}